import LazyLoad from 'vanilla-lazyload'
import Glightbox from 'glightbox'
import '../util/smoothscroll'

export default (() => {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 0) {
      $('header.main-header').addClass('is-scrolled');
    } else {
      $('header.main-header').removeClass('is-scrolled');
    }
  });

  new Glightbox({
    selector: 'blocks-gallery-item figure a',
  })

  new Glightbox({
    selector: 'entry-gallery figure a',
  })

  new Glightbox({
      selector: '.thor-achievements-gallery a',
      touchNavigation: true,
  });

  new LazyLoad({
    elements_selector: '.lazy',
  })

  // Price range filters
  const productsFilter = $('.filters-wrapper select')
  productsFilter.on('change', function() {
    const filter = $(this).val(); // get selected value
    if (filter) { // require a URL
      window.location = filter; // redirect
    }
    return false;
  });

  //Toggle details panel
  const toggleDetails = $('[data-toggle-details]')
  toggleDetails.map(function () {
    const target = $(this).attr('data-toggle-details')
    const detailsPanel = $(target)
    const closingPanelToggle = detailsPanel.find('[data-close-panel]')

    $(this).on('click', function () {
      detailsPanel.addClass('is-open');
      $('body').addClass('locked-details')
    })

    closingPanelToggle.on('click', function () {
      detailsPanel.removeClass('is-open');
      $('body').removeClass('locked-details')
    })
  })
})();


// WEBPACK FOOTER //
// ./scripts/layout/common.js